import { render, staticRenderFns } from "./award.vue?vue&type=template&id=60e3f9fa&scoped=true&"
import script from "./award.vue?vue&type=script&lang=js&"
export * from "./award.vue?vue&type=script&lang=js&"
import style0 from "./award.vue?vue&type=style&index=0&id=60e3f9fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e3f9fa",
  null
  
)

export default component.exports